import React from 'react';
import './pending-ecosystem-item.scss';

export default function PendingEcosystemItem() {
  return <div className="pending-ecosystem-item" />;
}
